import { LogBox } from 'react-native';
LogBox.ignoreAllLogs()
import Authenticator from "./Authenticator";
import ProfileManager from "./ProfileManager";
import * as Components from './Components';
import * as SocialComponents from './SocialComponents';
import { APIOverrides } from "./ApiOverrides";
import {LinearGradient} from "expo-linear-gradient";
import Colors from "./constants/colors";
import Observer, { BEEventApi, BELinkApi } from './Observer';
import BettorSearch from "./BettorSearch";
import MyWallet from "./Wallet";
import Checkout from "./Checkout";
import { usePlayerLocation } from "./LocationTracker/LocationStatus";
import PollCampaign from "./Poll";
import { PollCampaignApi, PollApi } from "./Poll/api";
import CompetitionModule from "./Competition";
import AdServer, { AdProvider } from "./AdServer";
import BracketRoom from "./Bracket";
import SocketManager from './Socket';
import SquaresModule from "./Squares";
import PromotedOrder from "./PromotedOrder";
import CompetitionManager from "./CompetitionManager";
import CreateCompetitionForm from "./CompetitionManager/components/CreateCompetitionForm";
import AdminCompetitionList from "./CompetitionManager/components/AdminCompetitionList";
import EngageModule from "./Engage";
import SeasonManager from "./CompetitionSeasonManager";
import SeasonModule from "./CompetitionSeason";
import CreateSeasonForm from "./CompetitionSeasonManager/components/CreateSeasonForm";
import MarketComponents from './MarketComponents';
import EventComponents from './EventComponents';
import Share from './Share';
import LocationTracker from "./LocationTracker";
import MarketMaker from "./MarketMaker";
import CompetitionCard from './Engage/components/CompetitionCard';
import SquaresCompetitionCard from './Engage/components/SquaresCompetitionCard';
import BracketCompetitionCard from './Engage/components/BracketCompetitionCard';
import SeasonCard from './Engage/components/SeasonCard';
import NotificationModule from './Notifications';
import { useNotifications } from './Notifications/useNotifications';
import ManageBracketCompetitionForm from './Bracket/components/ManageBracketCompetitionForm';
import Campaign from './Campaign';
import Ticker from './Ticker';
import Leaderboard from './Leaders';
import LeaderboardCard from './Leaders/components/LeaderboardCard';
import PlayerRecommender from './PlayerRecommender';
import ContactsCard from './PlayerRecommender/components/ContactCard';
import ContactsSelector from './PlayerRecommender/components/ContactsSelector';
import GolfScoreboard from './GolfScoreboard';
import FlashMarket from './FlashMarket';
import FlashHolder from './FlashMarket/FlashHolder';
import BEPostHog from './PostHog';
import BEClarity from './Clarity';
import BetMatch from './BetMatch';
import Premium from './Premium';
import ManageFilter from './BetMatch/components/ManageFilter';
import ClaritySmartEvents from './Clarity/SmartEvents';
import RankingsCard from './RankingsCard';
import GuideView from './Guide';
import GroupComponent from './Group';
import CreateGroupWizard from './Group/components/CreateGroupWizard';
import CreateEngagement from './CreateEngagement';
import SquaresManager from './SquaresManager';
import DiscordConnectionManager from './Discord';
import ManageFlashMarket from './FlashMarket/components/ManageFlashMarket';
import PartnerPortal from './PartnerPortal';
import EmbedManager from './PartnerPortal/components/EmbedManager';
import CreateEmbed from './PartnerPortal/components/CreateEmbed';
import ReferralCodeManager from './PartnerPortal/components/ReferralCodeManager';
import FlashCampaignManager from './PartnerPortal/components/FlashCampaignManager';
import MyAction from './MyAction';
import BettorBotDashboard from './BettorBot';
import NotificationManager from './NotificationManager';
import { NotificationApi, NotificationHelpers } from './NotificationManager/api';
import BetRouter from './BetRouter/index';

// Charts
export { LivePriceChart, BaseLineChart, TradeChartAdapter } from './Charts';
export type { Trade, TradeChartOptions, TimeSeriesPoint, TimeSeriesData, LivePriceChartProps } from './Charts';

export {
  Authenticator,
  Observer,
  MyAction,
  CreateEmbed,
  ReferralCodeManager,
  BetRouter,
  CreateEngagement,
  DiscordConnectionManager,
  BEEventApi,
  FlashCampaignManager,
  BettorBotDashboard,
  EmbedManager,
  RankingsCard,
  ManageFlashMarket,
  BELinkApi,
  PartnerPortal,
  SquaresManager,
  GuideView,
  BetMatch,
  ManageFilter,
  Ticker,
  Premium,
  CreateGroupWizard,
  LeaderboardCard,
  GroupComponent,
  LocationTracker,
  BEClarity,
  FlashMarket,
  ContactsCard,
  PlayerRecommender,
  GolfScoreboard,
  ContactsSelector,
  Campaign,
  BEPostHog,
  ManageBracketCompetitionForm,
  NotificationModule,
  FlashHolder,
  useNotifications,
  ClaritySmartEvents,
  ProfileManager,
  CompetitionManager,
  Components,
  SocialComponents,
  APIOverrides,
  LinearGradient,
  usePlayerLocation,
  BettorSearch,
  Colors,
  MyWallet,
  Share,
  Checkout,
  MarketComponents,
  EventComponents,
  PollCampaign,
  PollCampaignApi,
  PollApi,
  MarketMaker,
  CompetitionModule,
  SeasonManager,
  CreateCompetitionForm,
  CreateSeasonForm,
  SeasonModule,
  AdminCompetitionList,
  AdServer,
  Leaderboard,
  AdProvider,
  BracketRoom,
  SquaresModule,
  SocketManager,
  PromotedOrder,
  EngageModule,
  CompetitionCard,
  SquaresCompetitionCard,
  BracketCompetitionCard,
  SeasonCard,
  NotificationManager,
  NotificationApi,
  NotificationHelpers
}